module.exports = __webpack_public_path__ + "7c5550a28be11553d6017af0dd27a5dc.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/icons/twitter-icon.svg
 ** module id = 210
 ** module chunks = 0
 **/